export default "__VITE_ASSET__C3hYXEj7__"